import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {WhiteListComponent} from './list/list.component';
import {FirewallEditComponent} from './firewall-edit/firewall-edit.component';

export const routes: Routes = [
  {
    path: 'list',
    component: WhiteListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.PbxGroup,
      package: ModulesEnum.FirewallModule,
      permissions: [RolesEnum.Firewall_View, RolesEnum.Firewall_Edit, RolesEnum.Firewall_Delete],
      meta: {
        title: 'IP Whitelist',
        override: true,
        description: 'IP Whitelist Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'security',
        order: 3
      }
    }
  },
  {
    path: 'ipaddress',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: ':id',
            children: [
              {
                path: 'edit',
                component: FirewallEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.PbxGroup,
                  package: ModulesEnum.FirewallModule,
                  permissions: [RolesEnum.Firewall_Edit, RolesEnum.Firewall_Delete],
                  meta: {
                    title: 'Whitelisting IP Addresses',
                    override: true,
                    description: 'Edit IP Address Details Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'security',
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
];
